import React from "react";
import { personalInfo } from "../data/content";

function scrollToHash(hash) {
  const id = hash.replace(/^#/, "");
  const el = document.getElementById(id);
  if (!el) return;
  const top = el.getBoundingClientRect().top + window.scrollY - 80;
  const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  window.scrollTo({ top, behavior: reduce ? "auto" : "smooth" });
  if (history.pushState) history.pushState(null, "", `#${id}`);
}

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden border-b border-rule">
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 opacity-[0.07]"
        style={{
          backgroundImage:
            "repeating-linear-gradient(to right, #101311 0, #101311 1px, transparent 1px, transparent 64px), repeating-linear-gradient(to bottom, #101311 0, #101311 1px, transparent 1px, transparent 64px)",
        }}
      />

      <div className="wrap relative py-20 md:py-28 lg:py-36">
        <p className="label mb-6">
          {personalInfo.role}
          <span className="mx-2 text-rule">/</span>
          {personalInfo.positioning}
        </p>

        <h1 className="font-display text-[clamp(2.5rem,8vw,5.5rem)] font-semibold leading-[0.98] tracking-[-0.03em] text-ink">
          {personalInfo.name}
        </h1>

        <p className="mt-6 max-w-3xl font-display text-[clamp(1.5rem,3.5vw,2.5rem)] font-medium leading-[1.15] tracking-[-0.02em] text-ink">
          {personalInfo.statement}
        </p>

        <p className="mt-6 max-w-2xl text-base text-ink-secondary md:text-lg">
          {personalInfo.support}
        </p>

        <div className="mt-10 flex max-w-full flex-wrap items-center gap-3">
          <a
            href="#work"
            className="btn-primary"
            onClick={(e) => {
              e.preventDefault();
              scrollToHash("#work");
            }}
          >
            View selected work
          </a>
          <a
            href={personalInfo.resumeUrl}
            className="btn-secondary"
            target="_blank"
            rel="noopener noreferrer"
          >
            View resume
          </a>
          <a
            href="#contact"
            className="btn-secondary"
            onClick={(e) => {
              e.preventDefault();
              scrollToHash("#contact");
            }}
          >
            Contact
          </a>
        </div>

        <dl className="mt-16 grid grid-cols-2 gap-6 border-t border-rule pt-8 sm:grid-cols-4">
          {[
            { k: "Role", v: "Website Security Analyst" },
            { k: "Engineering", v: "Java · React · Python" },
            { k: "Credentials", v: "AWS Cloud · AWS AI" },
            { k: "Based in", v: personalInfo.location },
          ].map((item) => (
            <div key={item.k}>
              <dt className="label">{item.k}</dt>
              <dd className="mt-2 text-sm text-ink">{item.v}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}
